export const headerTableNews = [
  { id: 1, key: 'id', name: '№' },
  { id: 2, key: 'title', name: 'Название' },
  { id: 3, key: 'createdAt', name: 'Дата публикации' },
  { id: 4, key: 'actions', name: '' },
];

export const testData = [
  { id: 1, title: 'Новость 1', createdAt: '2025-02-20T10:00:00Z' },
  { id: 2, title: 'Новость 2', createdAt: '2025-02-21T12:30:00Z' },
  { id: 3, title: 'Новость 3', createdAt: '2025-02-22T14:45:00Z' },
  { id: 4, title: 'Новость 4', createdAt: '2025-02-23T09:15:00Z' },
];
